import * as React from 'react';
import { connect } from 'react-redux'

import { getMatchIdByChannelId } from '../reducers/timings'
import { getActiveChannelId } from '../reducers/gui'
import { getLanguage } from '../reducers/config'

import CallToAction from './CallToAction'

export const MobileSuiteHeader = ( props: { matchid: number } ) => {
  return (
    <div className="mobileSuiteHeader">
      <div className="mobileSuiteHeader-match">{props.matchid}</div>
      <div className="mobileSuiteHeader-countdown"><CallToAction /></div>
    </div>
  )
}

const mapStateTopProps = (state:any) => {
  return ({
    matchid: getMatchIdByChannelId(state, getActiveChannelId(state)),
    lang: getLanguage(state)
  })
}

export default connect(mapStateTopProps)(MobileSuiteHeader)